import { put, call, takeEvery } from "redux-saga/effects";

import * as apis from "../../network/apis/companies";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";

function* getRegistrationRequestsListSaga({ payload }) {
  try {
    const page = Number(payload.page) > 0 ? Number(payload.page) : 1;
    const status = payload.status || "pending";
    const response = yield call(apis.getCompanies, {
      status,
      page,
      items: payload.items,
      ...(payload.name && String(payload.name).trim()
        ? { name: String(payload.name).trim() }
        : {}),
    });
    const raw = response.data?.data ?? response.data;
    const list = Array.isArray(raw) ? raw : [];
    const meta = apis.metaFromCompaniesResponse(response);
    yield put(
      actions.getRegistrationRequestsResponse({
        list,
        meta,
      })
    );
    if (meta.pages > 0 && meta.currentPage > meta.pages) {
      yield put(
        actions.getRegistrationRequestsRequest({
          ...payload,
          page: meta.pages,
        })
      );
    }
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

function* editCompanyRegistrationSaga({ payload }) {
  try {
    const { id, page, items, name, status, refetchCompanyDetailId } = payload;
    yield call(apis.approveCompany, id);
    yield showSuccessMsg(
      "approveRequest"
    );
    yield put(
      actions.getRegistrationRequestsRequest({
        page,
        items,
        status,
        name,
      })
    );
    if (refetchCompanyDetailId != null) {
      yield put(
        actions.getCompanyDetailsRequest({
          id: refetchCompanyDetailId,
          force: true,
        })
      );
    }
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

export default function* RegistrationReqSagas() {
  yield takeEvery(
    types.GET_REGISTRATION_REQUESTS_REQUEST,
    getRegistrationRequestsListSaga
  );
  yield takeEvery(
    types.EDIT_COMPANY_REGISTRATION_REQUEST,
    editCompanyRegistrationSaga
  );
}
